import palette from '../../theme/palette'

export const listItemStyle = ({ isOpened }: { isOpened: boolean }) => ({
	padding: '0',
	svg: {
		minWidth: '24px',
	},
	'.usage-title': {
		mt: '40px',
	},
	'.usage-item-container': {
		width: '100%',
		display: 'flex',
		color: palette.colors.green,
		gap: '10px',

		'&.usage-title span': {
			fontSize: '14px',
			padding: '12px 8px 8px',
		},

		...(isOpened
			? {
					mx: '8px',
					columnGap: '16px',
					flexDirection: 'row',
					alignItems: 'center',

					'.report-details': {
						minWidth: 0,
						whiteSpace: 'normal',
					},
					'.report-details > span': {
						borderRadius: '4px',
						padding: '4px 12px',
						color: palette.colors.green,
						fontSize: '14px',
						minWidth: '80px',
						whiteSpace: 'normal',
					},
					'.report-details > span > div:first-child': {
						fontSize: '10px',
					},
				}
			: {
					margin: '8px',
					marginTop: '24px',
					marginBottom: '40px',
					border: '1px solid ' + palette.sidebar.borderGray,
					borderRadius: '4px',
					flexDirection: 'column',
					alignItems: 'center',
					padding: '8px 6px',
				}),
		'&.option': {
			columnGap: '6px',
		},
		'.MuiBox-root': {
			display: 'flex',
			justifyContent: 'flex-start',
		},
	},
})

export const listItemTextStyle = () => ({
	span: {
		div: {
			fontSize: '0.8rem',
			'&:first-child': {
				fontSize: '10px',
			},
		},
	},
})
